/**
 * Studio → Tools (parent layout) — outlets the index, create, and detail
 * routes underneath `/studio/tools`.
 *
 * Pre-fix this file rendered the list page directly with no `<Outlet />`,
 * so `/studio/tools/new` and `/studio/tools/$toolId` (which the route
 * tree registers as children of this route — see `routeTree.gen.ts`
 * `StudioToolsRouteChildren`) silently fell through to the list.
 * Codex audit findings #1 + #2.
 *
 * The list is now `tools.index.tsx` (matched at exactly `/studio/tools/`).
 * This file's job is just to give the children somewhere to render.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/tools')({
  component: StudioToolsLayout,
});

function StudioToolsLayout() {
  return <Outlet />;
}
